import theme from '@styles/theme';
export default {
  section: {
    background: theme.rawColors.lightGrey300,
    margin: 'auto',
    p: ['0', '0', '0', '0', '112px 0 '],
    'p.subtitle:last-of-type': {
      mb: 0
    }
  },
  subtitle: (last: boolean) => ({
    m: last ? ['0 auto 0', ' 0 auto 0', '0 auto 0', '0 auto 0', '0'] : ['0 auto 40px', ' 0 auto 40px', '0 auto 50px', '0 auto 50px', '0 0 42px'],
    maxWidth: ['100%', '100%', '478px', '478px', '460px'],
    fontSize: theme.fontSizes.text
  }),
  mainRow: {
    display: ['flex', 'flex', 'flex', 'flex', 'grid'],
    gridTemplateColumns: ['1fr', '1fr', '1fr', '1fr', '2fr 10fr 1fr 9fr 2fr'],
    gridAutoFlow: ['initial', 'initial', 'initial', 'initial', 'column'],
    gridGap: 0,
    flexDirection: 'column-reverse'
  },
  imageWrapper: {
    m: ['-135px 0 0', '-135px 0 0', '-250px 0 -68px', '-250px 0 -68px', '0'],
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    pb: [0, 0, '40px', '40px', 0],
    div: {
      width: '100%',
      position: 'relative',
      height: ['223px', '223px', '466px', '466px', '724px']
    }
  },
  info: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  infoWrapper: {
    textAlign: ['center', 'center', 'center', 'center', 'left'],
    height: ['auto', 'auto', 'auto', 'auto', '466px', '33.8vw'],
    maxHeight: ['none', 'none', 'none', 'none', '40.6em'],
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ['48px 16px 48px', '48px 16px 48px', '64px 16px 50px', '64px 16px 50px', '0 40px', '0 40px']
  }
};